import React from 'react';

import { Event } from '../../interfaces';
import { getBlockName } from '../../utils';
import { useFleet } from '../../hooks';
import { EventTypeIdentifier } from '../../enums';
import { Tooltip } from '../atoms';
import { useTranslatedBlockName } from '../../hooks/useTranslatedBlockName';

interface Props {
  event: Event;
}

export function Geocode(props: Props) {
  const text = getBlockName(props.event);
  const fleet = useFleet();
  const shouldUseTranslation = useTranslatedBlockName();

  const blockMappings = fleet.global_route_block_mapping;

  if (shouldUseTranslation && blockMappings) {
    const { block_name, route_direction } = props.event.metadata?.route_metadata ?? {};
    const stringForMatching = `${route_direction} ${block_name}`.toUpperCase();
    const eventType = props.event.event_type_identifier;

    let mappedBlockName = blockMappings[eventType]?.[stringForMatching];

    if (!mappedBlockName) {
      // Fallback to TEST event type if specific event type mapping is not found
      mappedBlockName = blockMappings[EventTypeIdentifier.TEST]?.[stringForMatching];
    }

    if (mappedBlockName) {
      return <Tooltip tooltip={text}>{mappedBlockName}</Tooltip>;
    }
  }

  return <>{text}</>;
}
